var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.95496 7.27593C0.839599 7.18216 0.746595 7.06386 0.682717 6.92962C0.618839 6.79538 0.585693 6.64859 0.585693 6.49993C0.585693 6.35127 0.618839 6.20448 0.682717 6.07024C0.746595 5.936 0.839599 5.81769 0.95496 5.72393L6.36896 1.32393C6.51564 1.20462 6.69314 1.12935 6.88087 1.10683C7.06859 1.08431 7.25886 1.11548 7.42959 1.19671C7.60033 1.27794 7.74453 1.40591 7.84549 1.56578C7.94644 1.72564 8 1.91086 7.99996 2.09993L7.99996 10.8999C8 11.089 7.94644 11.2742 7.84549 11.4341C7.74453 11.5939 7.60033 11.7219 7.42959 11.8031C7.25886 11.8844 7.06859 11.9155 6.88087 11.893C6.69314 11.8705 6.51564 11.7952 6.36896 11.6759L0.95496 7.27593Z",
    fill: "#525660"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame-1.8ff17a932189f4c66ebbd400e7a4f4b2.svg";
export { ForwardRef as ReactComponent };